import { render, staticRenderFns } from "./qrMusic.vue?vue&type=template&id=6380bbe8"
import script from "./qrMusic.vue?vue&type=script&lang=js"
export * from "./qrMusic.vue?vue&type=script&lang=js"
import style0 from "./qrMusic.vue?vue&type=style&index=0&id=6380bbe8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports